<template>
  <div>
    <div class="columns">
      <div class="column is-5 margin-fix-receipt-tab">
        <img v-if="receipt.document" v-document="receipt.document" class="full-width smooth-corners">
      </div>

      <form class="column">
        <b-tabs type="is-boxed" v-model="tab">
          <b-tab-item label="Details" icon="info"></b-tab-item>
          <b-tab-item label="Contrabonnen" icon="image"></b-tab-item>
        </b-tabs>

        <div v-show="tab === 0">
          <div class="field">
            <label class="label">Bonnummer</label>
            <div class="control">
              <input class="input" type="text" v-model="bonnummer">
            </div>
          </div>

          <div class="field">
            <label class="label">Artikel</label>
            <div class="select">
              <select v-model="article" v-validate="'required'" required>
                <option v-for="article in articles" :value="article.value">{{article.name}}</option>
              </select>
            </div>
          </div>

          <div class="field">
            <label class="label">BTW</label>
            <div class="select">
              <select v-model="vatCode" v-validate="'required'" required>
                <option v-for="vat in settings['accountview.vat.codes']" :value="vat.id">{{vat.name}}</option>
              </select>
            </div>
          </div>

          <b-field label="Datum">
            <b-datepicker
              placeholder="Selecteer..."
              v-model="datum"
              v-validate="'required'"
              required
              :readonly="false">
            </b-datepicker>
          </b-field>

          <b-field label="Debiteur">
              <b-autocomplete
                  ref="debiteurField"
                  v-model="debiteur.name"
                  :data="filterDebiteuren"
                  :placeholder="`bijv. ${debiteur.data[0] || ''}`"
                  @select="onDebiteurSelect"
                  :keep-first="true"
                  v-validate="'required'"
                  required
                  :readonly="false">
              </b-autocomplete>
          </b-field>

          <b-field label="Chauffeur">
              <b-autocomplete
                  ref="crediteurField"
                  v-model="crediteur.name"
                  :data="filterCrediteuren"
                  :placeholder="`bijv. ${crediteur.data[0] || ''}`"
                  @select="onCrediteurSelect"
                  :keep-first="true"
                  v-validate="'required'"
                  required>
              </b-autocomplete>
          </b-field>

          <div class="field">
            <label class="label">Kostenplaats</label>
            <div class="control">
              <textarea class="textarea" type="text" v-model="kostenplaats"></textarea>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">Ritprijs</label>
                <div class="control has-icons-left">
                  <input class="input" type="number" v-model="ritprijsChauffeur" @blur="berekenBTWRitprijsChauffeur" v-validate="'required'" required>
                  <span class="icon is-left">
                    <i class="fa fa-eur"></i>
                  </span>
                </div>
              </div>
            </div>

            <div class="column">
              <div class="field">
                <label class="label">BTW percentage</label>
                <div class="control has-icons-left">
                  <input class="input" type="number" v-model="ritprijsChauffeurBTW">
                  <span class="icon is-left">
                    <i class="fa fa-percent"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">Ritprijs factuur</label>
                <div class="control has-icons-left">
                  <input class="input" type="number" v-model="ritprijsFactuur" @blur="berekenBTWRitprijsFactuur" v-validate="'required'" required>
                  <span class="icon is-left">
                    <i class="fa fa-eur"></i>
                  </span>
                </div>
              </div>
            </div>

            <div class="column">
              <div class="field">
                <label class="label">BTW percentage</label>
                <div class="control has-icons-left">
                  <input class="input" type="number" v-model="ritprijsFactuurBTW">
                  <span class="icon is-left">
                    <i class="fa fa-percent"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="field">
            <label class="label">Factuurtekst</label>
            <div class="control">
              <textarea class="textarea" type="text" v-model="factuurText"></textarea>
            </div>
          </div>

          <div class="field">
            <label class="label">Toelichting</label>
            <div class="control">
              <textarea class="textarea" type="text" v-model="toelichting"></textarea>
            </div>
          </div>
        </div>

        <div v-show="tab === 1">
          <div class="columns">
            <div class="column is-6">
              <h3 class="title is-3">Geselecteerde bonnen:</h3>
              <hr>

              <div class="columns is-multiline">
                <div class="column is-12" v-for="bon, index in selected">
                  <figure class="image is-autoby200">
                    <img v-document="bon.id">
                  </figure>
                  <div class="columns receipt_footer">
                    <div class="column">
                      <div class="box-footer">
                        <div class="control">
                          <input class="input" type="number" v-model="bon.number" placeholder="bonnummer" v-validate="'required'" required>
                        </div>
                      </div>

                      <div class="box-footer">
                        <a class="button is-danger is-pulled-right" @click="removeContrabon(index)">Verwijderen</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="column is-6">
              <h3 class="title is-3">Beschikbare bonnen:</h3>
              <hr>

              <div class="columns is-multiline">
                <div class="column is-12" v-for="document in contrabonnen">
                  <figure class="image is-autoby200">
                    <img v-document="document">
                  </figure>
                  <div class="columns receipt_footer">
                    <div class="column">
                      <div class="box-footer">
                        <a class="button is-primary is-pulled-right" @click="addContrabon(document)">Toevoegen</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="spacing-top-20" v-if="!alreadyConcept">
          <button class="button is-info" :class="{'is-loading': saving}" @click="saveAsConcept">Opslaan als concept</button>
          <button class="button is-primary" :class="{'is-loading': saving}" @click="readyForConfirmation">Klaarzetten voor controle</button>
        </div>

        <div class="spacing-top-20" v-if="alreadyConcept">
          <button class="button is-info" :class="{'is-loading': saving}" @click="saveAndConfirmed">Opslaan</button>
        </div>
      </form>
    </div>

    <b-loading :active.sync="fetchingData"></b-loading>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  computed: {
    ...mapGetters([
      'debiteuren',
      'crediteuren',
      'settings'
    ]),
    ...mapGetters({
      allReceipts: 'allReceipts',
      conceptReceipts: 'conceptReceipts',
      incomplete: 'incompleteReceipts',
      articles: 'receiptArticles'
    }),
    receipts () {
      return this.allReceipts
    },
    filterDebiteuren () {
      if (!this.debiteur.name) {
        return
      }

      const searchQuery = this.debiteur.name.toLowerCase().split('/')

      const result = this.debiteur.data.filter((option) => {
        const debiteur = this.debiteuren.find((debiteur) => {
          return this.formatCrediteurDebiteurName(debiteur) === option
        })

        for (let query of searchQuery) {
          const isName = option
            .toString()
            .toLowerCase()
            .indexOf(query.toLowerCase()) >= 0
          const isNumber = String(debiteur.subNr).indexOf(query) >= 0

          if (isName || isNumber) {
            return true
          }
        }
      })

      return result
    },
    filterCrediteuren () {
      if (!this.crediteur.name) {
        return
      }

      const searchQuery = this.crediteur.name.toLowerCase().split('/')

      const result = this.crediteur.data.filter((option) => {
        const crediteur = this.crediteuren.find((crediteur) => {
          return this.formatCrediteurDebiteurName(crediteur) === option
        })

        for (let query of searchQuery) {
          const isName = option
            .toString()
            .toLowerCase()
            .indexOf(query.toLowerCase()) >= 0
          const isNumber = String(crediteur.subNr).indexOf(query) >= 0

          if (isName || isNumber) {
            return true
          }
        }
      })

      return result
    }
  },
  data () {
    return {
      receipt: {},
      contrabonnen: [],
      selected: [],
      article: '',
      debiteur: {
        data: [],
        name: '',
        selected: null
      },
      crediteur: {
        data: [],
        name: '',
        selected: null
      },
      bonnummer: '',
      datum: '',
      kostenplaats: '',
      ritprijsChauffeur: '',
      ritprijsFactuur: 'Ritprijs',
      factuurText: '',
      toelichting: '',
      tab: 0,
      vatCode: null,
      alreadyConcept: false,
      fetchingData: false,
      saving: false,
      ritprijsChauffeurBTW: 9,
      ritprijsFactuurBTW: 9
    }
  },
  async created () {
    this.fetchingData = true

    await this.$store.dispatch('getDebiteuren')
    await this.$store.dispatch('getCrediteuren')
    await this.$store.dispatch('getReceiptArticles')
    await this.$store.dispatch('getAllReceipts')
    await this.$store.dispatch('getAllReceipts')

    await this.$store.dispatch('getSettings', [
      'accountview.vat.codes'
    ])

    this.debiteur.data = this.debiteuren.map((object) => {
      return this.formatCrediteurDebiteurName(object)
    })
    this.crediteur.data = this.crediteuren.map((object) => {
      return this.formatCrediteurDebiteurName(object)
    })

    await this.setupPage()

    this.fetchingData = false
  },
  methods: {
    berekenBTWRitprijsChauffeur () {
      const incBTW = this.ritprijsChauffeur / Number(`1.${('0' + this.ritprijsChauffeurBTW).slice(-2)}`)
      const prijs = Math.round(incBTW * 100) / 100
      this.ritprijsChauffeur = prijs
    },
    berekenBTWRitprijsFactuur () {
      const incBTW = this.ritprijsFactuur / Number(`1.${('0' + this.ritprijsFactuurBTW).slice(-2)}`)
      const prijs = Math.round(incBTW * 100) / 100
      this.ritprijsFactuur = prijs
    },
    resetFields () {
      this.setCrediteur(null)
      this.setDebiteur(null)
    },
    async setupPage () {
      await this.$store.dispatch('getAllReceipts')
      const {id} = this.$route.params

      this.receipt = this.receipts.find(function (receipt) {
        return receipt.id === id
      })

      let {
        bonnummer,
        article,
        vatCode,
        datum,
        kostenplaats,
        debiteur,
        crediteur,
        ritprijsChauffeur,
        ritprijsFactuur,
        contrabonnen,
        factuurText,
        toelichting
      } = this.receipt

      this.article = article || this.articles[0].value
      this.bonnummer = bonnummer
      this.vatCode = vatCode || this.settings['accountview.vat.codes'][0].id
      this.datum = datum ? new Date(datum) : new Date()
      this.kostenplaats = kostenplaats
      this.ritprijsChauffeur = ritprijsChauffeur
      this.ritprijsFactuur = ritprijsFactuur
      this.factuurText = factuurText
      this.toelichting = toelichting

      if (this.receipt.state === 'CONFIRM') {
        this.alreadyConcept = true
      }

      this.setCrediteur(crediteur)
      this.setDebiteur(debiteur)

      contrabonnen = contrabonnen || []

      // Make sure that current receipt is not in the incomplete array
      const incomplete = this.incomplete.filter((object) => {
        return object.id !== this.receipt.id
      }).map((object) => {
        return object.document
      })

      this.selected = contrabonnen
      this.contrabonnen = incomplete
    },
    isValid () {
      const errors = this.$validator.errors.items

      if (errors.length > 0) {
        return false
      }

      return true
    },
    async saveAndConfirmed (e) {
      e.preventDefault()

      // const isValid = this.isValid()
      let { id } = this.receipt

      // if (!isValid) {
      //   return
      // }

      this.fetchingData = true

      await this.save()
      await this.$store.dispatch('setReceiptState', {
        id,
        state: 'confirm'
      })

      this.fetchingData = false

      this.$router.push({ name: 'invoices.confirmation' })
    },
    async nextReceipt () {
      let fallback, dest, source

      let {target} = this.$route.meta
      switch (target) {
        case 'processing':
          fallback = 'receipts.concept'
          dest = 'receipts.edit.processing'
          source = this.incomplete
          break
        case 'concept':
          fallback = 'invoices.confirmation'
          dest = 'receipts.edit.concept'
          source = this.conceptReceipts
          break
      }
      console.log(fallback, dest, source, source.length)

      if (source.length > 0) {
        const orderedSource = source.sort(function (a, b) {
          return moment(b.createdAt).diff(moment(a.createdAt))
        })

        let next
        for (let receipt of orderedSource) {
          if (receipt.id === this.receipt.id) {
            continue
          }

          next = receipt
          break
        }

        console.log(next.id)
        this.$router.push({ name: dest, params: { id: next.id } })
        window.scrollTo(0, 0)
        return
      }

      this.$router.push({ name: fallback })
    },
    async saveAsConcept (e) {
      e.preventDefault()
      const isValid = this.isValid()

      if (!isValid) {
        return
      }

      this.fetchingData = true
      await this.save()
      this.fetchingData = false

      await this.nextReceipt()
    },
    async readyForConfirmation (e) {
      e.preventDefault()

      let { id } = this.receipt
      const isValid = this.isValid()

      if (!isValid) {
        return
      }

      await this.save()
      await this.$store.dispatch('setReceiptState', {
        id,
        state: 'confirm'
      })

      await this.$store.dispatch('getConceptReceipts', true)
      await this.nextReceipt()
    },
    async save () {
      try {
        this.saving = true

        let { selected, bonnummer, article, datum, vatCode, debiteur, crediteur, kostenplaats, ritprijsChauffeur, ritprijsFactuur, factuurText, toelichting } = this
        let { id } = this.receipt

        debiteur = debiteur.selected
        crediteur = crediteur.selected

        await this.$store.dispatch('saveReceiptConcept', {
          id,
          article,
          bonnummer,
          datum,
          vatCode,
          debiteur,
          crediteur,
          kostenplaats,
          ritprijsChauffeur,
          ritprijsFactuur,
          factuurText,
          contrabonnen: selected,
          toelichting
        })

        await this.$store.dispatch('getIncompleteReceipts', true)
      } finally {
        this.saving = false
      }
    },
    setCrediteur (id) {
      if (!id) {
        this.$refs.crediteurField.setSelected('')
        this.crediteur.selected = ''
      }

      for (let object of this.crediteuren) {
        if (object.subNr === id || object.acctName === id) {
          this.$refs.crediteurField.setSelected(this.formatCrediteurDebiteurName(object))
        }
      }
    },
    setDebiteur (id) {
      if (!id) {
        this.$refs.debiteurField.setSelected('')
        this.debiteur.selected = ''
      }

      for (let object of this.debiteuren) {
        if (object.subNr === id || object.acctName === id) {
          this.$refs.debiteurField.setSelected(this.formatCrediteurDebiteurName(object))
        }
      }
    },
    onCrediteurSelect (object) {
      const crediteur = this.crediteuren.find((crediteur) => {
        return this.formatCrediteurDebiteurName(crediteur) === object
      })

      if (!crediteur) {
        return
      }

      this.crediteur.selected = crediteur.subNr
    },
    onDebiteurSelect (object) {
      const debiteur = this.debiteuren.find((debiteur) => {
        return this.formatCrediteurDebiteurName(debiteur) === object
      })

      if (!debiteur) {
        return
      }

      this.debiteur.selected = debiteur.subNr
    },
    removeContrabon (index) {
      const document = this.selected[index]
      this.selected.splice(index, 1)
      this.contrabonnen.push(document.id)
    },
    addContrabon (id) {
      for (let index in this.contrabonnen) {
        const document = this.contrabonnen[index]

        if (document !== id) {
          continue
        }

        this.contrabonnen.splice(index, 1)
        this.selected.push({
          id: document,
          number: ''
        })
      }
    },
    formatCrediteurDebiteurName (object) {
      return object.subNr + '/' + object.acctName
    }
  },
  watch: {
    '$route.params.id': function (id) {
      this.resetFields()
      this.setupPage()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/receipts/concept/edit.vue